(() => {
  document.querySelectorAll('[data-hera-faq-v3]').forEach((root) => {
    if (root.dataset.faqReady) return;
    root.dataset.faqReady = 'true';

    const search = root.querySelector('input[type="search"]');
    const clear = root.querySelector('.hera-faq-v3__clear');
    const reset = root.querySelector('[data-faq-reset]');
    const emptyReset = root.querySelector('[data-faq-empty-reset]');
    const count = root.querySelector('[data-faq-count]');
    const empty = root.querySelector('.hera-faq-v3__empty');
    const items = Array.from(root.querySelectorAll('[data-faq-item]'));
    const groups = Array.from(root.querySelectorAll('[data-faq-group]'));
    const buttons = Array.from(root.querySelectorAll('[data-faq-category]'));
    let activeCategory = 'all';

    const normalize = (value) => value.toLowerCase().trim().replace(/\s+/g, ' ');
    const tokenize = (value) => Array.from(new Set(normalize(value).split(' ').filter(Boolean)));
    const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const searchIndex = new Map(items.map((item) => [item, normalize(`${item.dataset.search || ''} ${item.textContent}`)]));

    const clearHighlights = (item) => {
      item.querySelectorAll('mark[data-faq-highlight]').forEach((mark) => {
        mark.replaceWith(document.createTextNode(mark.textContent));
      });
      item.querySelector('.hera-faq-v3__match-preview')?.remove();
      item.normalize();
    };

    const highlightText = (element, tokens) => {
      if (!element || tokens.length === 0) return;
      const expression = new RegExp(`(${tokens.slice().sort((a, b) => b.length - a.length).map(escapeRegExp).join('|')})`, 'gi');
      const tokenSet = new Set(tokens);
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          if (!node.nodeValue.trim() || node.parentElement?.closest('script, style, mark[data-faq-highlight]')) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      textNodes.forEach((node) => {
        const parts = node.nodeValue.split(expression);
        if (parts.length === 1) return;
        const fragment = document.createDocumentFragment();
        parts.forEach((part) => {
          if (part && tokenSet.has(normalize(part))) {
            const mark = document.createElement('mark');
            mark.dataset.faqHighlight = 'true';
            mark.textContent = part;
            fragment.append(mark);
          } else if (part) {
            fragment.append(document.createTextNode(part));
          }
        });
        node.replaceWith(fragment);
      });
    };

    const addMatchPreview = (item, tokens, rawQuery) => {
      const question = item.querySelector('summary > span:first-child');
      const answer = item.querySelector('.hera-faq-v3__answer');
      highlightText(question, tokens);
      highlightText(answer, tokens);
      if (question?.querySelector('mark[data-faq-highlight]')) return;

      const answerParts = Array.from(answer?.querySelectorAll('p, li') || []).map((node) => node.textContent);
      const answerText = (answerParts.length ? answerParts.join(' ') : answer?.textContent || '').replace(/\s+/g, ' ').trim();
      const normalizedAnswer = answerText.toLowerCase();
      let index = -1;
      let matchedToken = '';
      tokens.forEach((token) => {
        const candidate = normalizedAnswer.indexOf(token);
        if (candidate !== -1 && (index === -1 || candidate < index)) {
          index = candidate;
          matchedToken = token;
        }
      });

      const preview = document.createElement('p');
      preview.className = 'hera-faq-v3__match-preview';
      preview.setAttribute('aria-hidden', 'true');
      if (index !== -1) {
        const start = Math.max(0, index - 42);
        const end = Math.min(answerText.length, index + matchedToken.length + 78);
        preview.textContent = `${root.dataset.matchAnswer}: ${start > 0 ? '…' : ''}${answerText.slice(start, end)}${end < answerText.length ? '…' : ''}`;
      } else {
        preview.textContent = `${root.dataset.matchTopic}: ${rawQuery}`;
      }
      highlightText(preview, tokens);
      item.querySelector('details')?.insertAdjacentElement('afterend', preview);
    };

    const update = () => {
      const tokens = tokenize(search.value);
      let visible = 0;
      items.forEach((item) => {
        clearHighlights(item);
        const categoryMatch = activeCategory === 'all' || item.dataset.category === activeCategory;
        const searchable = searchIndex.get(item);
        const queryMatch = tokens.length === 0 || tokens.every((token) => searchable.includes(token));
        item.hidden = !(categoryMatch && queryMatch);
        if (!item.hidden) {
          visible += 1;
          if (tokens.length) addMatchPreview(item, tokens, search.value.trim());
        }
      });
      groups.forEach((group) => { group.hidden = !group.querySelector('[data-faq-item]:not([hidden])'); });
      const categoryLabel = buttons.find((button) => button.dataset.faqCategory === activeCategory)?.childNodes[0]?.textContent?.trim();
      const categoryText = activeCategory === 'all' ? '' : ` ${root.dataset.inCategory} ${categoryLabel}`;
      const queryText = tokens.length ? ` ${root.dataset.forQuery} “${search.value.trim()}”` : '';
      count.textContent = visible
        ? `${root.dataset.showing} ${visible} ${visible === 1 ? root.dataset.questionOne : root.dataset.questionOther}${categoryText}${queryText}`
        : `${root.dataset.noResults}${categoryText}${queryText}`;
      empty.hidden = visible !== 0;
      clear.hidden = tokens.length === 0;
      reset.hidden = activeCategory === 'all' && tokens.length === 0;
    };

    const setCategory = (category) => {
      activeCategory = category;
      buttons.forEach((button) => {
        const active = button.dataset.faqCategory === category;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      update();
    };

    const resetAll = (focus = false) => {
      search.value = '';
      setCategory('all');
      if (focus) search.focus();
    };

    const openHash = (scroll = false) => {
      const id = decodeURIComponent(window.location.hash.slice(1));
      if (!id) return;
      const target = document.getElementById(id);
      if (!target || !root.contains(target) || !target.matches('[data-faq-item]')) return;
      resetAll();
      const details = target.querySelector('details');
      if (details) details.open = true;
      if (scroll) target.scrollIntoView({ block: 'start' });
    };

    search.addEventListener('input', update);
    search.closest('form').addEventListener('submit', (event) => event.preventDefault());
    clear.addEventListener('click', () => { search.value = ''; update(); search.focus(); });
    reset.addEventListener('click', () => resetAll(true));
    emptyReset.addEventListener('click', () => resetAll(true));
    buttons.forEach((button) => button.addEventListener('click', () => setCategory(button.dataset.faqCategory)));
    root.querySelectorAll('.hera-faq-v3__anchor').forEach((link) => link.addEventListener('click', () => { link.closest('[data-faq-item]')?.querySelector('details')?.setAttribute('open', ''); }));
    window.addEventListener('hashchange', () => openHash(true));
    openHash();
    update();
  });
})();
